import { StateTree, defineStore } from 'pinia';

import { cookiesStorage } from 'SharedDir/stores/cookiesStorage';

export const usePersonalDataPolicyStore = defineStore('personal-data-policy', {
  persist: process.env.CLIENT
    ? {
        storage: cookiesStorage,
        // debug: true,
        /**
         * Оказывается мы все это время не верно использовали сохранение сторы в куки.
         * И работало это все только потому что задавалось на беке (ssr) и
         * летело в качестве INITIAL_STATE. Потому что pinia-persised.
         * Не гидрирцет стору, если не укзан десереализатор. А без опции debug можно об этом никогда не узнать
         * потому что только тогда в консоль пишется ошибка
         */
        serializer: {
          serialize: (data) => data as unknown as string,
          deserialize: (data) => data as unknown as StateTree,
        },
      }
    : false,

  state: () => ({
    cookiesWasAccepted: false,
  }),

  actions: {
    acceptCookies() {
      this.cookiesWasAccepted = true;
    },
  },
});
